import React, { useEffect, useState } from "react";

import { Box, Container, Grid, Typography, useTheme } from "@mui/material";

import {
  findGetParameter,
  postData,
} from "../../components/utilities/UtilityFunctions";
import { postNotification } from "../../components/utilities/Notifications";
import ModalLoadingFull from "../../components/modals/ModalLoadingFull";
import {
  BCPCircleCheck,
  BCPTriangleExclamation,
} from "../../components/icons/bcp/BCPIcons";

export default function StripeConfirmation() {
  const [processing, setProcessing] = useState(true);
  const [status, setStatus] = useState(null);

  const stripeCode = findGetParameter("code");
  const stripeState = findGetParameter("state");

  const theme = useTheme();

  useEffect(() => {
    const go = async () => {
      try {
        if (!stripeCode || !stripeState) {
          throw new Error("Missing required url parameters");
        }
        var apiResponse = await postData("/stripe/confirmExpress", {
          body: {
            code: stripeCode,
            state: stripeState,
          },
        });
        if (apiResponse?.id) {
          postNotification("success", "Stripe Account linked!");
          setStatus("Success");
        }
      } catch (err) {
        postNotification("error", err);
        setStatus("Error");
      }
      setProcessing(false);
    };
    go();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Container sx={{ pt: 2, pb: 2 }} maxWidth="lg">
          <Grid container sx={{ gap: 2 }}>
            <Grid
              item
              xs={12}
              sx={{
                p: 2,
              }}
            >
              <Typography variant="h3">Stripe Confirmation</Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                p: 2,
              }}
            >
              {status === "Success" && (
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Typography variant="h3">
                      <BCPCircleCheck color={theme?.palette?.success.main} />{" "}
                      Success
                    </Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <Typography variant="body1">
                      Payment acccount updated
                    </Typography>
                    <Typography variant="caption">
                      You can now set up online ticket sales for your events.
                    </Typography>
                  </Grid>
                </Grid>
              )}

              {status === "Error" && (
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Typography variant="h3">
                      <BCPTriangleExclamation color="theme?.palette?.error.main" />{" "}
                      Error
                    </Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <Typography variant="body1">
                      Payment acccount not created
                    </Typography>
                    <Typography variant="caption">
                      There was an error creating your stripe account. Please
                      try again later
                    </Typography>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Container>
      </Box>
      {processing && <ModalLoadingFull />}
    </>
  );
}
